const MAP = {
  published: { label: "Published", cls: "bg-emerald-500/15 text-emerald-400 border-emerald-500/30" },
  draft: { label: "Draft", cls: "bg-amber-500/15 text-amber-400 border-amber-500/30" },
  pending_review: { label: "Pending Review", cls: "bg-blue-500/15 text-blue-400 border-blue-500/30" },
  processing: { label: "Processing", cls: "bg-purple-500/15 text-purple-300 border-purple-500/30 animate-pulse" },
  hidden: { label: "Hidden", cls: "bg-red-500/15 text-red-400 border-red-500/30" },
  failed: { label: "Failed", cls: "bg-red-500/15 text-red-400 border-red-500/30" },
};

export const StatusBadge = ({ status, testid }) => {
  const m = MAP[status] || { label: status, cls: "bg-white/10 text-white/70 border-white/20" };
  return (
    <span
      data-testid={testid}
      className={`inline-flex items-center gap-1.5 text-[10px] font-mono uppercase tracking-[0.15em] px-2.5 py-1 rounded-full border ${m.cls}`}
    >
      {m.label}
    </span>
  );
};
